import type { IUserProfileRecentlyWatchedOffers as IUserProfileRecentlyWatchedOffersDto } from '../../../repositories/chats/entities/user_profile/UserProfileRecentlyWatchedOffers';
import type { IUserProfileRecentlyWatchedOffers } from '../../../types/userProfile';
import { mapRecentlyWatchedOffer } from './mapRecentlyWatchedOffer';

export const mapRecentlyWatchedOffers = (
  recentlyWatchedOffers: IUserProfileRecentlyWatchedOffersDto | null | undefined,
): IUserProfileRecentlyWatchedOffers | null => {
  if (!recentlyWatchedOffers) {
    return null;
  }

  const { title, offers } = recentlyWatchedOffers;

  return {
    title,
    offers: offers.map(mapRecentlyWatchedOffer),
  };
};
